// /* eslint react/prop-types: 0 */
// import React from "react";
// import { Route, Redirect } from "react-router-dom";
// import Cookies from "universal-cookie";
// //import PropTypes from "prop-types";

// function PrivateRoute({ component: Component, ...rest }) {
//   const cookies = new Cookies();

//   return (
//     <Route
//       {...rest}
//       render={(props) => {
//         //const pathObj = { ...rest.location.pathname };
//         //const thePath = pathObj[Object.keys(pathObj)[0]];
//         const enrolleeUser = cookies.get("lifesaferEnrollment");
//         if (!enrolleeUser) {
//           // not logged in so redirect to login page with the return url
//           return (
//             <Redirect
//               to={{
//                 pathname: "/intro",
//                 state: { from: props.location },
//               }}
//             />
//           );
//         }
//         // authorized so return component
//         return <Component {...props} {...rest} />;
//       }}
//     />
//   );
// }

// export { PrivateRoute };


/* eslint react/prop-types: 0 */
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import Cookies from "universal-cookie";

function PrivateRoute({ component: Component, ...rest }) {
  const cookies = new Cookies();
  const location = useLocation();
  const enrolleeUser = cookies.get("lifesaferEnrollment");

  if (!enrolleeUser) {
    return <Navigate to="/intro" replace state={{ from: location }} />;
  }

  return <Component {...rest} />;
}

export { PrivateRoute };

